import { render, staticRenderFns } from "./edit-campana-ticket.vue?vue&type=template&id=7dc705b0&scoped=true"
import script from "./edit-campana-ticket.vue?vue&type=script&lang=ts"
export * from "./edit-campana-ticket.vue?vue&type=script&lang=ts"
import style0 from "./edit-campana-ticket.vue?vue&type=style&index=0&id=7dc705b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc705b0",
  null
  
)

export default component.exports